import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import Login, { MIGRATIONS_ACCESS_USERS } from "./components/account/Login";
import ClientList from "./components/client/ClientList";
import ClientForm from "./components/client/ClientForm";
import CompanyList from "./components/company/CompanyList";
import CompanyForm from "./components/company/CompanyForm";
import UserList from "./components/user/UserList";
import UserForm from "./components/user/UserForm";
import GroupList from "./components/group/GroupList";
import GroupForm from "./components/group/GroupForm";
import RoleList from "./components/role/RoleList";
import RoleForm from "./components/role/RoleForm";
import SupportUserList from "./components/support/SupportUserList";
import SupportUserForm from "./components/support/SupportUserForm";
import NotificationList from "./components/notification/NotificationList";
import NotificationForm from "./components/notification/NotificationForm";
import NotificationBatchForm from "./components/notification/NotificationBatchForm";
import ConversationFeedbackList from "./components/conversation-feedback/ConversationFeedbackList";
import ConversationFeedbackDetail from "./components/conversation-feedback/ConversationFeedbackDetail";
import DataSyncList from "./components/data-sync/DataSyncList";
import DataSyncDetail from "./components/data-sync/DataSyncDetail";
import AutomationExecutionList from "./components/automation/AutomationExecutionList";
import AutomationExecutionDetail from "./components/automation/AutomationExecutionDetail";
import RenameEmployeeForm from "./components/support/RenameEmployeesForm";
import WebSocketsPage from "./components/support/WebSocketsPage";
import CloudUsersForm from "./components/cloud-users-form/CloudUsersForm";
import { CompanyProvider } from "./lib/context/CompanyContext";
import { UserProvider } from "lib/context/UserContext";
import { StatusMessageProvider } from "./lib/context/StatusMessageContext";
import { FlashMessageProvider } from "./lib/context/FlashMessageContext";
// import "./App.scss";

const NOTIFICATION_ONLY_USERS = ["lisatyler@deltek.com", "carleycorona@deltek.com"];

const isNotificationOnlyUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.email && NOTIFICATION_ONLY_USERS.includes(user.email.toLowerCase());
  } catch {
    return false;
  }
};

const isMigrationsOnlyUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.email && MIGRATIONS_ACCESS_USERS.includes(user.email.toLowerCase());
  } catch {
    return false;
  }
};

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("token") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

// Routes accessible only to full admins (blocks notification-only and migrations-only users)
const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!localStorage.getItem("token")) {
        return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
      }
      if (isNotificationOnlyUser()) {
        return <Redirect to="/notifications" />;
      }
      if (isMigrationsOnlyUser()) {
        return <Redirect to="/clients" />;
      }
      return <Component {...props} />;
    }}
  />
);

// Routes accessible to full admins and migrations-only users (blocks notification-only users)
const MigrationsRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!localStorage.getItem("token")) {
        return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
      }
      if (isNotificationOnlyUser()) {
        return <Redirect to="/notifications" />;
      }
      return <Component {...props} />;
    }}
  />
);

function App() {
  return (
    <div>
      <CompanyProvider>
        <UserProvider>
      <FlashMessageProvider>
        <StatusMessageProvider>
          <Router>
            <Switch>
            <Route exact path="/" component={Login} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/user/:support_user_uuid/login/:authorization_code" component={Login} />
              <Route exact path="/cloud-users-form/:client_uuid/:token" component={CloudUsersForm} />
              <Route exact path="/" component={Login} />
              <Route exact path="/logout" component={Login} />
              <MigrationsRoute exact path="/clients" component={ClientList} />
              <MigrationsRoute exact path="/client" component={ClientForm} />
              <MigrationsRoute
                exact
                path="/client/:uuid"
                component={ClientForm}
              />
              <AdminRoute exact path="/companies" component={CompanyList} />
              <AdminRoute exact path="/company" component={CompanyForm} />
              <AdminRoute
                exact
                path="/company/:uuid"
                component={CompanyForm}
              />
              <ProtectedRoute exact path="/notifications" component={NotificationList} />
              <ProtectedRoute exact path="/notification" component={NotificationBatchForm} />
              <ProtectedRoute exact path="/notification/:uuid" component={NotificationForm} />
              <AdminRoute exact path="/conversation-feedback" component={ConversationFeedbackList} />
              <AdminRoute exact path="/conversation-feedback/:uuid" component={ConversationFeedbackDetail} />
              <MigrationsRoute exact path="/data-syncs" component={DataSyncList} />
              <MigrationsRoute exact path="/data-sync/:client_uuid" component={DataSyncDetail} />
              <MigrationsRoute exact path="/automations" component={AutomationExecutionList} />
              <MigrationsRoute exact path="/automation/:execution_id" component={AutomationExecutionDetail} />
              <AdminRoute exact path="/users" component={UserList} />
              <AdminRoute exact path="/user/:uuid" component={UserForm} />
              <AdminRoute exact path="/groups" component={GroupList} />
              <AdminRoute exact path="/group/:uuid" component={GroupForm} />
              <AdminRoute exact path="/roles" component={RoleList} />
              <AdminRoute exact path="/role/:uuid" component={RoleForm} />
              <AdminRoute exact path="/support/users" component={SupportUserList} />
              <AdminRoute exact path="/support/user" component={SupportUserForm} />
              <AdminRoute exact path="/support/user/:uuid" component={SupportUserForm} />
              <AdminRoute exact path="/rename_employees" component={RenameEmployeeForm} />
              <AdminRoute exact path="/websockets" component={WebSocketsPage} />
            </Switch>
          </Router>
        </StatusMessageProvider>
        </FlashMessageProvider>
        </UserProvider>
      </CompanyProvider>
    </div>
  );
}
export default App;
